export default {
    txt_welcome: 'Welkom',
    txt_dataover: 'Overzicht van de gegevens',
    txt_chance: 'Mogelijkheden',
    txt_device: 'Toestel',
    txt_chinese: 'Chinese',
    txt_english: 'English',
    txt_malay: 'Malay',
    txt_reports: 'Geschiedenis',
    txt_setting: 'Instelling',
    txt_dymanager: 'Personeelsbeheer',
    txt_account: 'Account',
    txt_userstatus: 'Gebruikersidentiteit',
    txt_name: 'Naam',
    txt_contactway: 'Contact',
    txt_accountsafe: 'Accountbeveiliging',
    txt_basicinfo: 'Basisinformatie',
    txt_updatepassword: 'Paswoord aanpassen',
    txt_storeinfomation: 'Informatie werkplaats',
    txt_storename: 'Naam werkplaats',
    txt_storephone: 'Telefoonnummer werkplaats',
    txt_storeaddress: 'Adres van de werkplaats',
    txt_AppInfomation: 'App',
    txt_currentversion: 'Huidige versie',
    txt_software: 'Update software',
    txt_loginout: 'Ontkoppeling',
    txt_updatelanguage: 'Taal',
    txt_updateto: 'Update naar',
    txt_zwgx: 'Geen update',
    txt_dz: 'Zaakvoerder',
    txt_sh: 'Handelaar',
    txt_dy: 'Werknemer',
    txt_bdsj: 'Koppel de mobiele telefoon',
    txt_shxx: 'Handelsgegevens',
    txt_shname: 'Handelsnaam',
    txt_ssmd: 'Winkel',
    txt_bdsb: 'Bindapparaat',
    txt_mendian: 'Winkel',


    //数据总览模块
    txt_sTime: 'Selecteer periode',
    txt_car_check: 'Aantal gescande voertuigen',
    txt_findchance: 'Verkoopsmogelijkheden',
    txt_trackchace: 'Opvolging van de mogelijkheden',
    txt_transform: 'Aantal conversies',
    txt_TotalData: 'Overzicht',
    txt_xxsj: 'Gedetailleerde gegevens',
    txt_zhsj: 'Conversiegegevens',
    txt_TireWear: 'Bandenslijtage',
    txt_DataHopper: 'Trechter',
    txt_jdcc: 'Aantal voertuigen',
    txt_CheckCar: 'Aantal scans',
    txt_ChanceNum: "Verkoopleads Q'ty",
    txt_TrackNum: 'Aantal opvolgingen',
    txt_TranseformNum: 'Aantal conversies',
    txt_UnTrack: 'Niet opgevolgd',
    txt_l: 'Voertuigen',
    txt_Time: 'Tijd',
    txt_Device: 'Toestel',
    txt_car_plate: 'Nummerplaat',
    txt_Wear: 'Dragen',
    txt_Pwear: 'Ongelijkmatige',
    txt_NoData: 'Geen gegevens',
    txt_GoodState: 'Normaal',
    txt_Border: 'Limiet',
    txt_replace: 'Vervang onm.',
    txt_Total_Check: 'Totaal',
    txt_pmqk: 'Ongelijke slijtage',
    txt_LightWear: 'Ongelijke slijtage (licht)',
    txt_GraveWear: 'Ongelijke slijtage (ernstig)',
    txt_hwtj: "Rotatie Q'ty",
    txt_wxhw: 'Niet nodig te verwisselen',
    txt_xyhw: 'Verwisselen nodig',
    txt_jcxq: 'Bijzonderheden',
    txt_zhxq: 'Detailconversie',
    txt_cc: 'Voertuigen ',
    txt_bfb: '%',
    txt_ltxs: 'Bandenverkoop',
    txt_sldw: 'Uitlijning',
    txt_ddlph: 'Evenwicht',
    txt_dphhh: 'Evenwicht',
    txt_qt: 'Anderen',
    txt_zhqs: 'Trend verwisseling',
    txt_ltxl: "Bandenverkoop Q'ty",
    txt_ltfw: 'Bandenservice',
    txt_ckxq: 'Bijzonderheden',
    txt_jt: 'Vandaag',
    txt_zt: 'Gisteren',
    txt_bz: 'Deze week',
    txt_by: 'Deze maand',
    txt_sy: 'Vorige maand',
    txt_jn: 'Dit jaar',
    txt_zhcl: 'Aantal conversies (voertuigen)',
    txt_zhl: 'Aantal conversies',
    txt_bfb: '%',
    txt_abjx: 'Deel banden « Limiet »',
    txt_aljg: 'Deel banden « Vervang onmid. »',
    txt_qwpm: 'Deel banden « Lichte ongel. slijtage »',
    txt_ayzp: 'Deel banden « Ernstige ongel. slijtage »',
    txt_lingt: '0 Band',
    txt_yt: '1 Band',
    txt_et: '2 Banden',
    txt_st: '3 Banden',
    txt_ft: '4 Banden',

    //机会
    txt_xsjh: 'Mogelijkheden',
    txt_gzz: 'In opvolging',
    txt_clwb: 'Behandeling voltooid',
    txt_ckbg: 'Rapport controleren',
    txt_yxs: 'Alle gegevens werden afgebeeld',
    txt_zhuiz: 'Bijhouden',
    txt_tix: 'Herinnering voor opvolgong',
    txt_chuli: 'Proecss',
    txt_yzh: 'Omgezet',
    txt_wzh: 'Onbekeerd',
    txt_gzsmts: '{0}band heeft een aantal problemen，{1}zal in de winkel gaan voor ',
    txt_czbty: 'Niet akkoord',
    txt_yyx: 'Intentie',
    txt_ltyg: '1 Band',
    txt_ltkg: '2 Banden',
    txt_ltsang: '3 Banden',
    txt_ltsig: '4 Banden',
    txt_jhcl: 'Proecss',
    txt_jhztai: 'Staat mogelijkheid',
    txt_crquy: 'werkgebied',
    txt_chuliry: 'Behandeld door',
    txt_chulijg: 'Behandeling voltooid',
    txt_zhuanhuanr: 'Inhoud conversie',
    txt_zhuanhuaje: 'Bedrag conversie',
    txt_zhuanhuasj: 'Tijd conversie',
    txt_zhuanhuayx: 'Bedoeling',
    txt_xuanzesj: 'Duur selecteren',
    txt_tsdatawk: 'Gegevens kunnen niet worden opgeslagen als de status van verkoopleads leeg is',
    txt_qtxzhsj: 'Gelieve de geschatte conversietijd in te vullen',
    txt_qtxzhnr: 'Gelieve het serviceartikel in te vullen  ',
    txt_qtxzhsj: 'Gelieve de conversietijd in te vullen',
    txt_sbts: 'Gegevens opslaan is mislukt, controleer het netwerk',


    //设备
    txt_sbgl: 'Apparaatbeheer',
    txt_tj: 'Toevoegen',
    txt_gdssb: 'Totaal {0}',
    txt_sbbh: 'Toestelcode',
    txt_gjbb: 'Versie microprogramma',
    txt_tjsj: 'Toegevoegde uren',
    txt_zdgx: 'Automatische update',
    txt_gxgj: 'Apparaatupgrade',
    txt_jieb: 'Ontkoppelen',
    txt_sbtsxx: 'Apparaat heeft updates, klik om bij te werken',
    txt_wjh: 'Niet geactiveerd ',
    txt_lix: 'Off line',
    txt_zaix: 'On line',
    txt_guz: 'Schuld',
    txt_yijieb: 'Ontkoppeld',
    txt_yihuis: 'Gerecycleerd',
    txt_gxsbgj: 'Upgrade apparaat',
    txt_gxsbgjts: 'Wilt u het apparaat upgraden?',
    txt_socketdk: 'Er is geen verbinding met de server, probeer opnieuw',
    txt_cscgts: 'Aanvraag voor update van het microprogramma succesvol verzonden',
    txt_jbsb: 'Ontkoppeld apparaat',
    txt_jbsbts: 'Wilt u het apparaat los koppelen.',
    txt_tscg: 'Succesvol',
    txt_zdgxgj: 'Automatische update',
    txt_gxgjts: 'Bent u zeker dat u de automatische update van het microprogramme wilt activeren/desactiveren?',
    txt_beiz: 'Opmerkingen',
    txt_qtxbz: 'Voer het commentaar in',
    txt_bdsbts: 'Deze apps worden gebruikt voor de intelligente detector van het loopvlakdiepte van de band, zorg ervoor dat het apparaat goed is.',
    txt_qdksb: 'Schakel het apparaat in',
    txt_dksbts1: '1、De bindingsvoorkeert wordt gestart nadat het nieuwe apparaat is ingeschakeld.',
    txt_dksbts2: '2、Als het apparaat eerder aan andere winkels is gebonden, klikt u op "ontkoppelen" in het menu "Instellingen" van het apparaat om het apparaat los te koppelen. Nadat het apparaat is losgekreet, gaat het automatisch naar het bindingsproces',
    txt_xyb: 'Volgende',
    txt_qsclj: 'DELETE',
    txt_qscts1: 'Gebruik het apparaat om de QR-code te scannen, als de scanbewerking is geslaagd, piept het apparaat.',
    txt_qscts2: 'Succesvol gescand',
    txt_sbtssmcg: 'Succesvol gescand',
    txt_ddsblw: 'Wachten op netwerken',
    txt_zznlbd: 'bindend',
    txt_qszdd: 'Het kan tientallen seconden duren, wacht alstublieft',
    txt_bdcg: 'Toestel succesvol verbonden',
    txt_tjcg: 'Succesvol toegevoegd',
    txt_tjcgts: 'Gefeliciteerd, het toestel is succesvol toegevoegd. Voer de naam van het toestel in om het gemakkelijk terug te vinden.',
    txt_fhsblb: 'Keer terug naar de apparaatlijst',
    txt_jxtjsb: 'Ga door met het toevoegen van het apparaat',
    txt_bzmc: 'Opmerking',


    //检测记录
    txt_sx: 'Kiezen',
    txt_khsj: 'Mobiele telefoon voor klanten',
    txt_cphm: 'Nummerplaat',
    txt_cphm1: 'Nummerplaat',
    txt_clxh: 'Voertuigmodel',
    txt_xgbz: 'Wijziging van opmerkingen',
    txt_gtfjl: 'Totaal',
    txt_jcsj: 'Tijdstip van de scan',
    txt_jcsj1: 'Tijdstip van de scan',
    txt_xzkssj: 'Starttijd ',
    txt_xzjssj: 'Eindtijd',
    txt_jcjg: 'Resultaat',
    txt_msqk: 'Dragen',
    txt_jygh: 'Vervangen',
    txt_zysh: 'Grens',
    txt_zcsy: 'Normaal',
    txt_zc: 'Normaal',
    txt_cz: 'Reïnitialisatie',
    txt_qd: 'Bevestig',
    txt_jcjgd: 'Resultaat',
    txt_msqkd: 'Dragen',
    txt_sldwd: 'Uitlijning',
    txt_jyghd: 'Vervanging wordt aanbevolen',
    txt_zysh: 'Let op het verlies',
    txt_zcsyd: 'Normaal gebruik',
    txt_xdwd: 'Positionering vereist',
    txt_xzyd: 'Nota',
    txt_zcd: 'Normaal',
    txt_bgxq: 'Rapport Details',
    txt_ljdy: 'Print van verbinding',
    txt_fwmd: 'Werkplaats',
    txt_mddz: 'Adres van de werkplaats',
    txt_jcsb: 'Testuitrusting',
    txt_ddmd: 'Doel',
    txt_lic: 'Kilometerstand',
    txt_chex: 'Type voertuig',
    txt_jcjyi: 'Aanbevelingen voor de scan',
    txt_ysbs: 'Identificatie van de kleur',
    txt_ztms: 'Algemene slijtage',
    txt_hwms: 'Ongelijkmatige',
    txt_dqscjltx: 'Huidige remafstand',
    txt_bgxqts: '备注：该测试由独立测试中心天津汽车检测中心进行，所用车辆为奥迪品牌FV7203BECGB型乘用车，轮胎规格为：245/40 R18,轮胎充气压力为：前胎230kpa，后胎220kpa；测试场地为：卡达克盐城测试地；所计算的车辆制动距离的速度范围:从100公里/小时减速至0公里/小时。',
    txt_wxsmgz: '微信扫码关注 TyreHub 公众号',
    txt_hwmsjh: 'Gelijkmatige slijtage van de groeven',
    txt_zqlun: 'Wiel links voor',
    txt_zhlun: 'Wiel links achter',
    txt_yqlun: 'Wiel rechts voor',
    txt_yhlun: 'Wiel rechts achter',
    txt_pingjunzhi: 'Gemiddeld',
    txt_guige: 'Maat',
    txt_gongli: 'Kilometerstand',
    txt_ltwjc: 'Band niet gedetecteerd',
    txt_pinpai: 'Merk',
    txt_ltws: 'Hoek banden',
    txt_sewmts: 'Scan QR-code\nBeeld rapport',
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Toevoegen',
    txt_qy: 'Actief',
    txt_qyz: 'Werkend',
    txt_ty: 'Uitgeschakeld',
    txt_yhzh: 'Gebruikersaccount',
    txt_lxfs: 'Telefoonnummer',
    txt_cjsj: 'Creatietijd',
    txt_bjxx: 'Bewerken',
    txt_xgmm: 'Paswoord aanpassen',
    txt_bgzt: 'Wijzig de status',
    txt_qdytjm: 'Zorg ervoor dat u het account uitschakelt？',
    txt_tjdy: 'Medewerker toevoegen',
    txt_bjdyxx: 'Werknemersgegevens bewerken',
    txt_zhxx: 'Account informatie',
    txt_ygxm: 'Naam van de werknemer',
    txt_qtxygxm: 'Voer de naam van de werknemer in',
    txt_lxdh: 'Contactgegevens',
    txt_qtxyglxdh: 'Telefoonnummer',
    txt_dxyzm: 'SMS-verificatiecode',
    txt_qtxdxyzm: 'Voer de verficatiecode in',
    txt_fsdx: 'Sms versturen',
    txt_tjzh: 'Account toevoegen',
    txt_baocun: 'Redden',
    txt_gtgygzh: 'Totaal {0}',



    //登录
    txt_qdytcdlm: 'Klaar om uit te loggen',
    txt_qx: 'Annuleer',
    txt_dl: 'Inloggen',
    txt_qsrzh: 'Voer de account-ID in',
    txt_qsrmm: 'Voer uw wachtwoord in',
    txt_zcshzh: 'Registreer voor handelaar',
    txt_shzhwjmm: 'Passowrd vergeten',
    txt_yzdqmm: 'Controleer het huidige paswoord',
    txt_szxmm: 'Maak een nieuw paswoord',
    txt_xgcg: 'Met succes gewijzigd',
    txt_qtxjmm: 'Voer het oude paswoord in',
    txt_yzzcsj: 'Mobiele telefoon verifiëren',
    txt_qtxxmm: 'Voer een nieuw wachtwoord in',
    txt_qzctxxmm: 'Herhaal nieuw wachtwoord',
    txt_lcmmsrbyz: 'De twee wachtwoorden zijn inconsistent',
    txt_gxnxgcg: 'Wachtwoord gewijzigd',
    txt_qljndxmm: 'Onthoud uw nieuwe wachtwoord',
    txt_fhgrzx: 'Terug naar persoonlijk centrum',
    txt_fsyzm: 'Verzend de controlecode',
    txt_qtxzcsjh: 'Voer uw mobiele telefoon in',
    txt_qtxtxyzm: 'Gelieve de grafische code in te vullen',
    txt_qsryzm: 'Voer de controlecode in',
    txt_qszhhmm: 'Stel een wachtwoord in dat bestaat uit 6 tot 18 cijfers en letters',
    txt_qzcsrmm: 'Voer het nieuwe paswoord in.',
    txt_lcmmbyz: 'Herhaal wachtwoord',
    txt_hdsy: 'Terug naar hoofdpagina',
    txt_zcshh: 'Registreer voor handelaar',
    txt_fhdl: 'Terug naar inlogpagina',
    txt_wlqqsb: 'Internet abnormaal, probeer het opnieuw',
    txt_wczc: 'Inschrijving afgerond',
    txt_wsts: ' Voltooi andere informatie voordat u de app gaat gebruiken.',
    txt_qtxshmc: 'Vul de naam van de verkoper in',
    txt_shmc: 'Handelsnaam',
    txt_rgszjd: 'vb. : vast telefoonnummer, ander telefoonnummer, werkfax, enz.',
    txt_qtlxfs: 'Ander contact',
    txt_kssy: 'Begin te gebruiken',
    txt_Pwear1: 'Ongelijkmatige',
    txt_open: 'Openen',
    txt_close: 'Sluiten',
    txt_srczhdmm: 'Vul het nieuwe wachtwoord in',
    txt_kcfs: '{0} s',
    txt_xiugai: 'Modificeren',
    txt_zzjzsj: 'Laden',
    txt_bjshxx: 'Verkopersgegevens bewerken',
    txt_chongxinhq: 'Opnieuw verzenden',
    txt_gaibangsj: 'Mobiele telefoon wijzigen',
    txt_yanzhengjsj: 'Oude mobiele telefoon verifiëren',
    txt_bangdingxsj: 'Binden aan nieuwe mobiele telefoon',
    txt_yhqsyxsjdl: 'Gelieve in te loggen met een nieuwe mobiele telefoon',



    //登录新
    txt_xzshenfen: 'Selecteer uw rol',
    txt_dlrolewz: 'Inloggen',
    txt_qsrsjh: 'Voer uw telefoonnummer in',
    txt_zhuce: 'Zich inschrijven',
    txt_wanjimima: 'Paswoord vergeten',
    txt_wanshandzxx: 'Gelieve de informatie in te vullen',
    txt_qsrxm: 'Voer uw naam in',
    txt_qsrmdm: 'Voer de winkelnaam in',
    txt_qsrmdgddh: 'Voer het telefoonnummer in',
    txt_qsrmddz: 'Voer het winkeladres in',
    txt_qsrgsdz: 'Voer het bedrijfsadres in',
    txt_qsrxxdz: 'Voer het detailadres in ',
    txt_tijiaocg: 'Succesvol ingediend',
    txt_qsvbsylwmm: 'Wachtwoord niet minder dan 6 digitals',
    txt_zhucerole: 'Registreren',
    txt_qsrshh: 'Voer het verkopersaccount in',
    txt_qsrdzh: 'Voer het manageraccount in',
    txt_wsshhzl: 'Vul de verkopersinformatie in',
    txt_wsdyhzl: 'Vul de personeelsinformatie in',
    txt_qsrshm: 'Voer de naam van de verkoper in (bedrijfsnaam)',
    txt_qsrshz: 'Voer de eigenaar van de verkoper in',
    txt_qsrzrqy: 'Voer het werkgebied in',
    txt_shanghudizhi: 'Adres van de verkoper',
    txt_yhycz: 'Gebruiker bestaat al',
    txt_qsrzqdzh: 'Voer het juiste manageraccount in',
    txt_qsrzqshh: 'Voer het juiste verkopersaccount in',
    txt_xzmdcx: 'Selecteer de winkel die u wilt opvragen',



    //门店
    txt_mendianId: 'Winkel ID',
    txt_mendianmc: 'Winkelnaam',
    txt_mendiandz: 'Adres van de werkplaats',
    txt_mendiandh: 'Telefoonnummer werkplaats',
    txt_caozuo: 'Opereren',
    txt_mendiangl: 'Werkplaatsbeheer',
    txt_gjmendian: '{0} winkels totaal',
    txt_zhengchangyy: 'Openen',
    txt_tingye: 'Buiten dienst',
    txt_gengdxx: 'Meer',
    txt_dianygl: 'Personeelsbeheer',
    txt_biangzt: 'Wijzig de status',
    txt_qdygbzhuangtai: 'Zorg ervoor dat u de winkel uitschakelt?',
    txt_bjmendian: 'Bedrijfsgegevens bewerken',
    txt_xinzenmd: 'Nieuwe winkel toevoegen',
    txt_qtxmdmc: 'Gelieve de winkelnaam in te vullen.',
    txt_qxzmddz: 'Selecteer winkeladres',
    txt_qtxxdz: 'Selecteer winkeladres',
    txt_xiangxidz: 'Detail adres',
    txt_qtxmddh: 'Voer het telefoonnummer van de werkplaats in',
    txt_dzxx: 'Manager informatie',
    txt_chaungjianmendian: 'Maak een bedrijf aan',
    txt_mendianxxxx: 'Gedetailleerde informatie',
    txt_bianji: 'Bewerken',
    txt_mendianzt: 'Werkplaatsstaat',

    //商户数据总览
    txt_mendianshuju: 'Gegevens opslaan',
    txt_chakangdxxbb: 'Bekijk meer rapporten',
    txt_jczcs: 'Totale inspectie',
    txt_mdpjjc: 'Gemiddelde inspectie',
    txt_jdzcl: 'Totale voertuigstroom',
    txt_jcl: 'Inspectiepercentage',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: 'Overzicht',
    txt_xiangqbb: 'Bijzonderheden',
    txt_xuanzerqckxxsj: 'Selecteer datum',
    txt_qxzsjd: 'Selecteer periode',
    txt_sjdts: 'U kunt alleen een periode van minder dan 30 dagen selecteren',
    txt_zonglan: 'Overzicht',
    txt_qushi: 'Trend',
    txt_shuliangtj: 'Hoeveelheidsstatistieken',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: "Trend van inspectie Q'ty",
    txt_msqkslqs: 'Trend van bandenslijtage',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: "Totale inspectie Q'ty",
    txt_shuliang: "Q'ty",
    txt_zhanbi: '%',
    txt_chankangd: 'Meer',
    txt_chakanmdxxbb: 'Bijzonderheden',


    //国家
    txt_zhongguo: 'China',
    txt_mlxy: 'Malaysia',
    txt_yindu: 'India',
    txt_taiguo: 'Tailand',
    txt_oluosi: 'Russia',



    txt_taici: 'Aantal stations',
    txt_jianyi: 'Aanbeveling:',
    txt_jianyineirong: 'Er is excentrieke slijtage in de band, verdere inspectie wordt aanbevolen',
    txt_jianyineirongzc: 'Normaal',
    txt_bgtixing: 'herinnering:',
    txt_bgtuxubfnr: 'Volgens de slijtage van de banden is de remafstand {0}% langer (geschat)',
    txt_waishang: 'Beschadiging',
    txt_laohua: 'Veroudering',
    txt_gubao: 'Zwelling',
    txt_xichemeirong: 'Car wash and beauty',
    txt_weixiubaoyang: 'onderhoud',
    txt_guenghuanluntai: 'verwissel band',
    txt_scsltjcy: 'Handhouddetector banden',
    txt_shijiantishi: 'De eindtijd moet groter zijn dan de starttijd',

    txt_qxzclry: 'Selecteer de verwerker',
    txt_lf_outworn: 'De buitenzijde van de band LV is meer afgesleten dan de binnenzijde',
    txt_lf_innerworn: 'De binnenzijde van de band LV is meer afgesleten dan de buitenzijde',
    txt_lf_bothsideworn: 'De beide zijkanten van de band LV zijn meer afgesleten dan het midden',
    txt_lf_centreworn: 'Het midden van de band LA is meer afgesleten dan de beide zijkanten',
    txt_lb_outworn: 'De buitenzijde van de band LA is meer afgesleten dan de binnenzijde',
    txt_lb_innerworn: 'De binnenzijde van de band LA is meer afgesleten dan de buitenzijde',
    txt_lb_bothsideworn: 'De beide zijkanten van de band LA zijn meer afgesleten dan het midden',
    txt_lb_centreworn: 'Het midden van de band LA is meer afgesleten dan de beide zijkanten',
    txt_rb_outworn: 'De buitenzijde van de band RA is meer afgesleten dan de binnenzijde',
    txt_rb_innerworn: 'De binnenzijde van de band RA is meer afgesleten dan de buitenzijde',
    txt_rb_bothsideworn: 'De beide zijkanten van de band RA zijn meer afgesleten dan het midden',
    txt_rb_centreworn: 'Het midden van de band RA is meer afgesleten dan de beide zijkanten',
    txt_rf_outworn: 'De buitenzijde van de band RV is meer afgesleten dan de binnenzijde',
    txt_rf_innerworn: 'De binnenzijde van de band RV is meer afgesleten dan de buitenzijde',
    txt_rf_bothsideworn: 'De beide zijkanten van de band RV zijn meer afgesleten dan het midden',
    txt_rf_centreworn: 'Het midden van de band RV is meer afgesleten dan de beide zijkanten',
    txt_tire_need_replace: 'Slijtage van de band, vervang onmiddellijk',

    txt_alignment_chassis: 'Het is aanbevolen om de uitlijning van de 4 wielen of het chassis te controleren',

    txt_do_further_check: 'Controleer verder',
    txt_uneven_check: 'Als de band abnormaal wordt gedragen, wordt aanbevolen om de dynamische balans, vierwieluitlijning en ophanging systeem te controleren',
    txt_tire_rotation: 'Het is aanbevolen om de banden van plaats te verwisselen',
    txt_wear_normal: 'Normale slijtage van de band',
    'txt_wear_normal;': 'Normale slijtage van de band',
    txt_tire: 'Band',
    txt_xiazai: 'Downloaden',
    txt_xiazaishibai: 'Downloaden mislukt',
    txt_appname: 'Leadshub',
    txt_dianjixiazaiandroid: 'Download Android-versie',
    txt_dianjixiazaiios: 'Download iOS-versie',






    txt_gelie: 'Split',
    txt_diaokuai: 'Block dropping',
    txt_chaungci: 'Punctie',
    txt_cashang: 'Kras',
    txt_yichang: 'Uitzondering',
    txt_qjybjcltazqk: 'Controleer de bandeninstallatie verder',
    txt_wear_overall: 'Algemene slijtage',
    txt_pattern_wear: 'Abnormale slijtage',
    txt_tire_age: 'Leeftijd banden',
    txt_tire_appearance: 'Hoek banden',
    txt_tire_age_5: 'De band is meer dan vijf jaar geldig. Het wordt aanbevolen om de band te vervangen.',
    txt_tire_age_3: 'De band is langer dan drie jaar geldig, controleer het regelmatig.',
    txt_tire_age_8: 'De band is meer dan vijf jaar geldig. Het wordt aanbevolen om de band te vervangen.',
    txt_tire_age_6: 'De band is langer dan drie jaar geldig, controleer het regelmatig.',
    txt_tire_age_ok: 'Goede banden leven',
    txt_tire_trauma_check: 'Er is letsel op het loopvlak, verdere inspectie wordt aanbevolen.',
    txt_install_abnormal_check: 'Als de band omgekeerd is geïnstalleerd, wordt verdere inspectie aanbevolen.',
    txt_tire_appearance_ok: 'Goede bandenopbouw',
    txt_ltlcgstm: 'Volgens de huidige slijttoestand van de band is het bandenbereik {0}km (geschatte waarde)',
    'txt_tire_need_replace;': 'als er bandenslijtage is, moet het onmiddellijk worden vervangen.',
    'txt_uneven_check;': 'Als de band abnormaal wordt gedragen, wordt aanbevolen om de dynamische balans, vierwieluitlijning en ophanging systeem te controleren',
    txt_tire_rotation: 'Aanbevolen wiel verplaatsen',
    'txt_tire_age_ok': 'Goede banden leven',
    'txt_wear_uniform;': 'Een enkele band slijtage is meer uniform',
    txt_wear_uniform: 'Een enkele band slijtage is meer uniform',
    'txt_tire_boundary;': 'Sommige banden worden gedragen en in grensstaat',
    txt_tire_boundary: 'Sommige banden zijn gedragen tot de grens staat',
    txt_plcl: 'Batch',
    txt_qbxz: 'Alles selecteren',
    txt_scjcjg: 'Laatste testresultaat',
    txt_ltxhlcgs: 'Raming van het bandenbereik',
    txt_ltazhuang: 'Montage van banden:',
    txt_dqltlctx: 'De huidige band heeft de limiet bereikt, verander de band onmiddellijk.',
    txt_dottx: 'Schatting van de levensduur van de banden',
    txt_danweinian: '(eenheid: jaar)',
    txt_danweikm: '(eenheid:km)',
    txt_myhqdsj: 'Het is niet de tijd om te scoren.',
    txt_dotjstx: 'De resterende gebruikstijd van de band is ongeveer {0}dagen',
    txt_dotjstx2: 'De levensduur van de band is overschreden vijf jaar, vervang het onmiddellijk',
    txt_dotsjztx: '(DOT:Datum van de vervaardiging van banden)',
    'txt_tire_age_ok;': 'Goede banden leven',


    //微信公众号
    txt_mdmz: '门店姓名',
    txt_mddzz: '门店地址',
    txt_sbid: '设备ID',
    txt_jsxm: '技师姓名',
    txt_shoujhm: '手机号码',
    txt_dxyzmm: '短信验证码',


    txt_jishimz: 'Technicus',
    txt_ltlcgsnew: 'Het bandenbereik is {0} km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: 'Slijtage van Pinnaat',
    txt_msjxtx: 'De band heeft de limiet bereikt, vervang hem onmiddellijk.',
    txt_ltfz: 'Binnenuit achteruit',
    txt_install_check: 'Inspectie van de installatie',
    txt_install_ok: 'De installatie is normaal',
    LF: '[linkervoorwiel]',
    RF: '[rechtervoorwiel]',
    LB: '[linkerachterwiel]',
    RB: '[rechter achterwiel]',
    FF: '[vooras]',
    BB: '[achteras]',
    txt_appearance_check: 'De band is beschadigd, repareer en bevestig.',
    txt_uneven_center: 'Het wordt aanbevolen de bandenspanning te controleren op abnormale slijtage in het midden van de band',
    txt_uneven_out: 'Het wordt aanbevolen de uitlijning van vier wielen en de bandenspanning te controleren op abnormale slijtage aan de buitenkant van de band,',
    txt_pinnate_check: 'Er is veren slijtage op de band. Het wordt aanbevolen om de onderdelen van het chassis verder te controleren',
    txt_uneven_inside: 'Als de binnenzijde van de band abnormaal wordt gedragen, wordt aanbevolen om de vierwieluitlijning en bandenspanning te controleren',
    'txt_do_further_check;': 'Controleer verder',
    txt_uneven_bothside: 'Het wordt aanbevolen de uitlijning van vier wielen en de bandenspanning te controleren',

    txt_msyzljgh: 'De band is ernstig gedragen, vervang hem onmiddellijk',
    txt_serious_trauma_check: "De band heeft ernstige verwondingen, het wordt aanbevolen om de band te vervangen",
    txt_appearance_lookup: "Controleer het uiterlijk van de band",
    txt_wear_lookup: "Controleer de slijtage van de band",
    txt_dotscsj: 'Productietijd: {0} ({2} week van {1} jaar)',
    txt_whqdscsj: 'Production time not obtained',
    purp_tireservice: 'Tire service',
    purp_vehicle_inspection: 'Vehicle inspection',

    txt_qiao: 'Def',
    txt_left: 'Sec',
    txt_right: 'Def',
    txt_lun: 'Def',
    txt_huawen: 'Patroon',
    txt_taihao: 'Bandennummer',
    txt_taiya: 'Bandendruk',
    txt_chexlw: 'Model wiel positie',
    txt_jiancerenyuan: 'Inspecteur',
    txt_beitai: 'reserveband',
    txt_tuoche: 'Trailer',
    txt_guache: 'Trailer',
    txt_chassis_check: 'Chassis-controle',
    txt_chassis_ok: 'Het chassis is in goede staat',
    txt_chassis_oil: 'De schokdemper lekt olie. Het wordt aanbevolen om verdere bevestiging te maken en te vervangen indien nodig.',
    txt_chassis_aging: 'Het rubber van de schacht wordt ouder. Het wordt aanbevolen om het te vervangen',
    txt_chassis_more: 'Het voertuig heeft een rubberveroudering aan de askop en de olielekkage van schokdemper is abnormaal. Het wordt aanbevolen om onderhoud en behandeling uit te voeren',
    chassis_oil: 'Olielekkage van schokdemper',
    chassis_aging: 'Aging van rubber met schacht',
    chassis_normal: 'Normaal',
    //cormach
    txt_hood: 'MOTORKAP',
    txt_wash_liquid: 'RUITENSPROEIERVLOEISTOF',
    txt_level_control: 'CONTROLE NIVEAU',
    txt_haoxiaoxi: 'OK',
    txt_vedi_Note: 'LEES NOTA',
    txt_replace1: 'VERVANGEN',
    txt_radiator_fluid: 'KOELVLOEISTOF',
    txt_engine_oil: 'MOTOROLIE',
    txt_brake_fluid: 'REMVLOEISTOF',
    txt_quality_control: 'KWALITEITSCONTROLE',
    txt_multimeter: 'MULTIMETER TEST',
    txt_subtotal: 'ONDER CHASSIS',
    txt_shock_absorber: 'SCHOKDEMPERS',
    txt_check_loss: 'COTROLE OP ZICHTBARE LEKKEN',
    txt_brake_disc: 'REMSCHIJVEN',
    txt_wear_condition: 'SLIJTAGENIVEAU',
    txt_brake_pads: 'REMBLOKKEN',
    txt_change_control: 'CHANGE CONTROL',
    txt_air_control: 'AIRCO',
    txt_last_reload: 'LAATSTE VULLING',
    txt_lighting: 'LICHTEN',
    txt_verification1: 'RUITENWISSERS',
    txt_dynamometer: 'AANDRAAIEN MET DYNAMOMETER GEDAAN DOOR',
    txt_batteria: 'BATTERIJ',
    txt_verification: 'CONTROLE WERKING',
    txt_levellow: 'OK',
    txt_levelmiddle: 'LEES NOTA',
    txt_levelhigh: 'VERVANGEN',
    txt_tyrenumber: 'Scanning depth:',
    txt_cormach_title: 'Wear&Uneven',
    txt_wearlow: 'normal',
    txt_wearmiddle: 'slight wear',
    txt_wearhigh: 'severe wear',
    txt_namtishi: 'Tread Depth in 32nds',
    txt_zhiliangkongzhi: 'Quality control',
    txt_buchongzhengduan: 'Supplementary Diagnosis',
    txt_season_summer: 'Zomer band',
    txt_season_winter: 'Winter band',
    //米其林新加
    txt_trauma_eattyre: 'Eet de baby',
    txt_uneven_eattyre: 'Aanbevolen wordt het dynamisch balanceren en het vierwieluitlijning- en ophangingssysteem te controleren',
    txt_appearance_eattyre: 'Het wordt aanbevolen om dynamisch balanceren uit te voeren en de vierwieluitlijning en ophanging te controleren',
    txt_chassis_eattyre: 'Aanbevolen wordt de uitlijning en ophanging van vier wielen te controleren',
    txt_uneven_high_eattyre: 'Als de band ernstig beschadigd is, wordt aanbevolen de band te vervangen en de vierwielige uitlijning en ophanging te controleren',
    txt_appearance_high_eattyre: 'Als de band ernstig beschadigd is, wordt aanbevolen om dynamisch balanceren uit te voeren en de vierwielige uitlijning en ophanging te controleren',
    txt_chassis_high_eattyre: 'Aanbevolen wordt de uitlijning en ophanging van vier wielen te controleren',
    txt_chassis_uneven: 'Als de band abnormaal wordt gedragen, wordt aanbevolen om de vierwielige uitlijning en ophanging te controleren',
    txt_pianmoyichang: 'Abnormale banden excentrieke slijtage',

    txt_khxm:'Customer Name',
    txt_khyx:'Customer Mail',

}


// WEBPACK FOOTER //
// ./src/i18n/nl.js